import React, { useEffect } from "react";
import { OSM, Vector as VectorSource } from "ol/source";
import { Circle, Fill, Style } from "ol/style";
import { Feature, Map, View } from "ol/index";
import { Point } from "ol/geom";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { useTranslation } from "react-i18next";
const MapComp = () => {
  const { t } = useTranslation();
  useEffect(() => {
    var place = [5720252.816532238, 4257792.819396444];
    var point = new Point(place);
    var place2 = [5720900, 4257100];
    var point2 = new Point(place2);
    var place3 = [5722900, 4259000];
    var point3 = new Point(place3);

    var map = new Map({
      view: new View({
        center: [5720252.816532238, 4257792.819396444],
        zoom: 13,
      }),
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        new VectorLayer({
          source: new VectorSource({
            features: [new Feature(point)],
          }),
          style: new Style({
            image: new Circle({
              radius: 9,
              fill: new Fill({ color: "red" }),
            }),
          }),
        }),
        new VectorLayer({
          source: new VectorSource({
            features: [new Feature(point2)],
          }),
          style: new Style({
            image: new Circle({
              radius: 9,
              fill: new Fill({ color: "green" }),
            }),
          }),
        }),
        new VectorLayer({
          source: new VectorSource({
            features: [new Feature(point3)],
          }),
          style: new Style({
            image: new Circle({
              radius: 9,
              fill: new Fill({ color: "blue" }),
            }),
          }),
        }),
      ],
      target: "map",
    });
  }, []);

  return (
    <div>
      <div id="map" style={{ width: "100%", height: "100vh" }}></div>
      <div
        className="d-flex flex-wrap justify-content-center"
        style={{ position: "absolute", bottom: "90px", left: "0", right: "0" }}
      >
        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
          <span className="profileAddUser bg-white d-block cursor icon-seti"></span>
          <small className="fn10 mt-1">{t("تنظیمات")}</small>
        </div>
        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
          <span className="profileAddUser bg-white d-block cursor icon-off"></span>
          <small className="fn10 mt-1">{t("خاموش")}</small>
        </div>
        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn10 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
    </div>
  );
};

export { MapComp };
